import firebase from "firebase/app";
import "firebase/auth";

const fb_config = {
	apiKey: "AIzaSyCQUDoM40mo5nehdpN_ehcITZWKJHPyxyc",
	authDomain: "app.syn.bike",
	projectId: "synfire-2020",
	appId: "1:390088636586:web:54ff1aa0c8a11a284038d3"
};

//Initialize firebase
firebase.initializeApp(fb_config);


//Initialize firebase auth
export const auth = firebase.auth();

export async function fs_login(type) {
	if (type === 'login') {
		const res = {}
		const loginRes = await firebase.auth().getRedirectResult()
			.catch((err) => {
				res.msg = err.message;
				res.code = err.code;
				res.error = true;
			})
		if (res.error) { return res; }
		return {
			error: false,
			credential: loginRes.user ? loginRes.credential.toJSON() : null,
		}
	}

	let res = {
		msg: 'success',
		error: false,
		code: '',
	}

	//Clear auth persistence immediately
	await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE)
		.catch((err) => {
			res.code = err.code;
			res.error = true;
			res.msg = err.message;
		});

	if (res.error) { return res; }

	let provider = false;
	//Setup provider for ms login
	if (type === 'ms') {
		provider = new firebase.auth.OAuthProvider('microsoft.com');
		provider.setCustomParameters({
			// Force re-consent.
			prompt: 'consent',
		});
	}

	//Setup provider for google login
	if (type === 'google') {
		provider = new firebase.auth.GoogleAuthProvider();
		provider.setCustomParameters({
			prompt: 'select_account',
		});
		provider.addScope('profile');
		provider.addScope('email');
	}

	if (!provider) { return { error: true, code: 'no-provider' } }

	// window.location.hash = "redirecting"
	history.replaceState({}, '', '/?type=login');

	await auth.signInWithRedirect(provider)
		.catch((err) => {
			res.code = err.code;
			res.error = true;
			res.msg = err.message;
		});

	return res;
}